import { render, staticRenderFns } from "./menuOrderFactor.vue?vue&type=template&id=09df9796&scoped=true"
import script from "./menuOrderFactor.vue?vue&type=script&lang=js"
export * from "./menuOrderFactor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09df9796",
  null
  
)

export default component.exports